<!-- エラーメッセージ画面　システムエラー -->
<template>
  <section class="crly-o-error-error-msg-system">
    <!-- タイトル -->
    <div class="crly-o-error-error-msg-system__title">
      {{ $t("errorMsgSystem.system.title") }}
    </div>
    <!-- -->
    <div class="crly-o-error-error-msg-system__contents">
      <!-- メッセージ -->
      <p class="crly-o-error-error-msg-system__message emphasis">
        {{ $t("errorMsgSystem.system.text1") }}
      </p>
      <p class="crly-o-error-error-msg-system__detail">
        {{ $t("errorMsgSystem.system.text2") }}
      </p>
      <!-- カスタマーセンター -->
      <p class="crly-o-error-error-msg-system__customer-center">
        {{ $t("errorMsgSystem.system.customer") }}
      </p>
      <p class="crly-o-error-error-msg-system__tell">
        {{ $t("errorMsgSystem.system.tell") }}
      </p>
      <!-- 受付時間 -->
      <p class="crly-o-error-error-msg-system__time">
        {{ $t("errorMsgSystem.system.time") }}
      </p>
      <p class="crly-o-error-error-msg-system__note">
        {{ $t("errorMsgSystem.system.note") }}
      </p>
    </div>
    <!--　フッター　コピーライト -->
    <div class="crly-o-error-error-msg-system__footer">
      <p>{{ $t("errorMsgSystem.system.copyright") }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "CrlyOrganismsErrorMsgSystem"
};
</script>

<style lang="scss">
@import "@crly/assets/css/common/common.scss";
@import "@crly/assets/css/organisms/error/errorMsgSystem.scss";
</style>
